import { Box, Button, Checkbox, Dialog, FormControl, IconButton, MenuItem, Select, TextField, Typography, Tooltip } from "@mui/material";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";

import _ from "lodash";
import { getDataSource } from "api/ds";
import { ReportTable } from "components/reportTable";
import { loginSelector } from "store/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import Loading from "components/Load";
//import { onChange } from "store/slices/fbs-fbo";
import { delFts, getFile, post, postImage } from "api/apiBridges/httpBridge";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import Scrollbars from "rc-scrollbars";
import useOn from 'components/socketLib/UseOn';
import { MarketClientSelector } from "store/slices/marketClient";
import { get } from "api/apiBridges/httpBridge"
import { useLocalNotifications } from "components/Events";
import { SelectProductTocopy } from "components/EIComponents/ProductInfo";
import ClassicSearch from "components/classicSearch";
import { colors } from 'styles/colors';
import usePreventDoubleClick from "components/AntiDBC";
import { SocketContext } from "components/socketLib/ConnectorSocket";
import { onChangeUploadImage } from "store/slices/uploadImage";
import NoPhoto from '../images/others/noPhoto.png';
import { NumInput, TextInput, TextNumInput } from "components/EIComponents/LittleComponents";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { ShowModal } from "components/Modal";
import DownloadIcon from '@mui/icons-material/Download';
import { useDataContextDeal } from "actions/contextDealClient";
import { SelectMarketLocal } from "components/SelectMarket";
import { hoverStyle } from "styles/main";


export function ClientsProducts() {
    
    const ds = useMemo(() => getDataSource('ClientProductsAdmin'), []);
    const [rawData, setRawData] = useState([]);
    // const [data, setData] = useState([]);

    const { dataContext, clearContextData } = useDataContextDeal();
    const [cli_id, setCli_id] = useState(undefined)
    const { company_id} = useSelector(
            loginSelector
        );
    
    const [market, setMarket] = useState('wb');
    const [loading, setLoading] = useState(false);
    
    
    //Настройки Фильтра
    const [checked, setChecked] = useState(false);
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
            brand: {name: "Брэнд", active: true},
            vendorCode: {name: "Артикул", active: true},
            barcode: {name: "ШК", active: true},
        }
    );
        
    const { showNotification } = useLocalNotifications();

    useEffect(() => {
        if (dataContext && dataContext.cli_id) {
          setCli_id(dataContext.cli_id)
          clearContextData();
        }
    }, [dataContext]);

    const fetchData = useCallback(async () => {
        // todo проверка какой маркет выбран
        // добавленный товар исключать путем запроса
        setLoading(true);
        if (cli_id) {
          const cliRecvReq = await get('UserRekv/get', {uid:cli_id});
          let cliRecv = {}
          if (cliRecvReq?.message) {
              cliRecv = JSON.parse(cliRecvReq.message.data)
          }
          if (market !== "custom") {
            // получаем данные с парсера 
            let res = []
            let isToken = await get('Clients/checkClientAPIKey', {uid:cli_id, market:market})
            if (isToken){
              switch (market) {
              case "wb":
                  res = await ds.getWBCardAndStocks(cli_id);
                  break;
              case "ozon":
                  res  = await ds.getOZONCardAndStocks(cli_id);
                  break;
            }
            }else {
              showNotification({
                  id: 'checkToken', 
                  type: 'error', 
                  message: 'У клиента не указан API ключ.' 
              });
            }       
            
            for (const el of res) {
                //el['expanded'] = [];
                let elsizes = [...el.data.sizes]
                delete el.data.sizes
                el.id=el.nmID || el.group_id 
                let sizes_name = ""
                let ttc = 0
                let cqc = 0
                let tcq = 0
                let tempExpanded = []
                elsizes.map((size) => {
                    console.log('size', size)
                    sizes_name += `${size.title}, `
                    if (size.techTask?.versions && Object.keys(size.techTask.versions).length >0) ttc++
                    if (size.countQr && parseInt(size.countQr)>0) {cqc++; tcq += parseInt(size.countQr)}
                    let tzs = size.techTask.versions? Object.keys(size.techTask.versions): []
                    let TZV = tzs.length>0?tzs[0]: 'main'
                    tempExpanded.push(
                      {
                        ...el, 
                        data: {
                          ...el.data, 
                          vendorCode: size.vendorCode || el.data.vendorCode, 
                          barcode: size.barcode, 
                          print: size.techTask?.versions[TZV]?.print || 'classic',
                          sizeTitle:size.title,
                          vendor: cliRecv?.name,
                        },
                        id:`${el.id};${size.barcode}`, 
                        size:{...size, stocks: size.stocks.sort((a,b) => {return b.stocks - a.stocks}), countQr: size.countQr || 0}, 
                        techTask: {...size.techTask, barcode: size.barcode, title: el.data.title, vendorCode: el.data.vendorCode, TZV},
                        qrcode:{id: `${el.nmID};${size.barcode}`, nmID: el.nmID, title: el.data.title, size, market: 1, company: company_id, count: size.countQr, vendorCode: el.data.vendorCode}
                      }
                    ) 
                })
                el['expanded'] = tempExpanded
                el.size = {total: el.data.totalCount, stocks: [], title: sizes_name.slice(0,-2), barcode:"", countQr: tcq}
                el.qrcode = {progress: (cqc/el['expanded'].length)*100}
                el.techTask = {progress: (ttc/el['expanded'].length)*100}
                
            }

            // const sortedRes = [...res].sort((a, b) => {
            //   return b.data.totalCount - a.data.totalCount;
            // });

            console.log("result", res)
            setRawData(res);
          }
          else {
            let res = await get("custom_product/getOnCli", {cid:cli_id})
            const sortedRes = res.sort((a, b) => b.nmId - a.nmId)
            for (const el of sortedRes) {
                //el['expanded'] = [];
                let elsizes = [...el.data.sizes]
                delete el.data.sizes
                el.id=el.nmID 
                let sizes_name = ""
                let ttc = 0
                let cqc = 0
                let tcq = 0
                let tempExpanded = []
                elsizes.map((size) => {
                    console.log('size', size)
                    sizes_name += `${size.title}, `
                    if (size.techTask?.versions && Object.keys(size.techTask.versions).length >0) ttc++
                    if (size.countQr && parseInt(size.countQr)>0) {cqc++; tcq += parseInt(size.countQr)}
                    tempExpanded.push(
                      {
                        ...el, 
                        // vendorCode: size.vendorCode || el.vendorCode, 
                        id:`${el.nmID};${size.barcode}`, 
                        size:{...size, stocks: size.stocks.sort((a,b) => {return b.stocks - a.stocks}), countQr: size.countQr || 0}, 
                        techTask: {...size.techTask, barcode: size.barcode, title: el.data.title, vendorCode: el.data.vendorCode},
                        qrcode:{id: `${el.nmID};${size.barcode}`, nmID: el.nmID, title: el.data.title, size, market: 1, company: company_id, count: size.countQr, vendorCode: el.data.vendorCode}
                      }
                    ) 
                })
                el['expanded'] = tempExpanded
                el.size = {total: el.data.totalCount, stocks: [], title: sizes_name.slice(0,-2), barcode:"", countQr: tcq}
                el.qrcode = {progress: (cqc/el['expanded'].length)*100}
                el.techTask = {progress: (ttc/el['expanded'].length)*100}
                
            }

            setRawData(sortedRes);
          }
          setLoading(false);
        }

      }, [ds, market, cli_id]);

    useEffect(() => {
        fetchData();
    }, [market, cli_id]);


    const changeTableRow = async ($data) => {
      if ($data.tzPrice) {
        changePrice($data)
        return
      }
      else {
        changeTechText($data)
      }
    }

    const changePrice = async ($data) => {
      let foundIndex = -1;
      let foundExpIndex = -1;
      let tmp = JSON.parse(JSON.stringify(rawData))
      // Находим индексы
      foundIndex = tmp.findIndex((el) => String(el.id) === String($data.row.id));
      if (foundIndex !== -1) {
        foundExpIndex = tmp[foundIndex].expanded.findIndex((el) => String(el.id) === String($data.row.expId));
      }

      if (foundExpIndex !== -1) {
        let TZV = tmp[foundIndex].expanded[foundExpIndex].techTask.TZV
        if (tmp[foundIndex].expanded[foundExpIndex].techTask.versions[TZV]) {
          tmp[foundIndex].expanded[foundExpIndex].techTask.versions[TZV].price = $data.count
          await post('tz_price/update', {barcode: tmp[foundIndex].expanded[foundExpIndex].techTask.barcode, client_id: cli_id, market, tz:TZV, price: $data.count})
          setRawData(tmp)
        }
      }
    };

    // Обработка изменений технического задания
    const changeTechText = async ($data) => {
      if ($data.swap) {
        let foundIndex = -1;
        let foundExpIndex = -1;
        let tmp = JSON.parse(JSON.stringify(rawData))
        // Находим индексы
        foundIndex = tmp.findIndex((el) => String(el.id) === String($data.row.id));
        if (foundIndex !== -1) {
          foundExpIndex = tmp[foundIndex].expanded.findIndex((el) => String(el.id) === String($data.row.expId));
        }

        if (foundExpIndex !== -1) {
          tmp[foundIndex].expanded[foundExpIndex].techTask.TZV = $data.swap
          tmp[foundIndex].expanded[foundExpIndex].data.print =tmp[foundIndex].expanded[foundExpIndex].techTask?.versions?.[$data.swap].print
        }
        setRawData(tmp)
      }
    };

    

    console.log('MY PROD DATA', rawData.length)
    const totalSKU = rawData.reduce((sum, item) => {
      const expandedLength = Array.isArray(item.expanded) ? item.expanded.length : 0;
      return sum + expandedLength;
    }, 0);

    const totalTechTask = rawData.reduce((total, row) => {
      if (!Array.isArray(row.expanded)) return total;
        const countInRow = row.expanded.filter(item => {
        const versions = item.techTask?.versions;
        return (
          versions && 
          typeof versions === 'object' && 
          Object.keys(versions).length > 0
        );
      }).length;

      return total + countInRow;
    }, 0);

    if (loading && rawData.length === 0) {
      return <Loading></Loading>
    }

    return (
        <Box sx={{height: '100%' }}>    
          <div style={{
            display: 'flex', 
            flexDirection: 'row', 
            alignItems: "center", 
            justifyContent: "space-between", 
            height:'10%',
            width: '98%',
            margin: "1%" 
          }}>
            <ClassicSearch 
              setChecked={setChecked} 
              setFilter={setFilter} 
              checked={checked}
              fields={filterFields}
              setFields={setFilterFields}
            />

            <div style={{display: 'flex', flexDirection: 'row', alignItems: "center"}}>
              <SelectMarketLocal markets={['wb', 'ozon', 'custom']} market={market} save={(m) => {setMarket(m)}} user_id={cli_id} />
              
              <Box sx={{
                zIndex: 10,
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'white',
                padding: '15px 20px',
                marginLeft: '10px', 
                borderRadius: '12px',
                boxShadow: '0px 4px 12px rgba(0,0,0,0.08)',
                minWidth: '250px',
                minHeight: '52px', 
                height: 'auto' 
            }}>
                <Box sx={{ 
                    display: 'flex', 
                    gap: '20px', 
                    alignItems: 'center', 
                    flexDirection: "row",
                    flexWrap: 'wrap' 
                }}>
                    <Typography sx={{ fontSize: '11pt', whiteSpace: 'nowrap' }}>
                        SKU: {totalSKU} шт.
                    </Typography>
                    <Typography sx={{ fontSize: '11pt', whiteSpace: 'nowrap' }}>
                        Товаров: <Typography component="span" sx={{ fontSize: '11pt', color: 'inherit' }}>{rawData.length} шт.</Typography>
                    </Typography>
                    <Typography sx={{ fontSize: '11pt' }}>
                        Заполнено ТЗ: <Typography component="span" sx={{ fontSize: '11pt', color: 'inherit' }}>в {totalTechTask} из {totalSKU} SKU</Typography>
                    </Typography>
                </Box>
            </Box>
            </div>
        </div>
        <div style={{
            width: '98%', 
            height: '85%', 
            overflow: 'hidden',
            margin: "1%",
            borderRadius: "10px"
        }}>
            {loading? <Loading></Loading>: 
              <Scrollbars
                // autoHeight
                // autoHeightMax={"98%"}
                style={{ width: '100%', height: '100%', borderRadius: "10px" }} 
                renderView={({ style, ...props }) => (
                    <div 
                    {...props} 
                    style={{ 
                        ...style, 
                        paddingRight: '10px',   // отступ справа под вертикальный скролл
                        paddingBottom: '10px',   // отступ снизу под горизонтальный скролл
                        backgroundColor: "#ffffff",
                    }} 
                    />
                )}
                // Настройка горизонтального ползунка
                renderThumbHorizontal={({ style, ...props }) => (
                    <div
                        {...props}
                        style={{
                            ...style,
                            backgroundColor: "#808080",
                            height: "10px",
                            borderRadius: "5px",
                            cursor: "pointer"
                        }}
                    />
                )}
                renderThumbVertical={({ style, ...props }) => (
                    <div
                        {...props}
                        style={{
                            ...style,
                            backgroundColor: "#808080",
                            width: "10px",
                            borderRadius: "5px",
                            cursor: "pointer"
                        }}
                    />
                )}
              >
                <div style={{ paddingBottom: '20px', opacity: loading ? 0.5 : 1, pointerEvents: loading ? 'none' : 'all' }}>
                  <ReportTable
                    ds={ds}
                    data={!checked ? rawData : rawData.filter((el) => {
                      const tf = filter.toLowerCase();
                      return (
                        filterFields.title.active &&
                          el.data.title &&
                          String(el.data.title).toLowerCase().includes(tf) ||
                        filterFields.brand.active &&
                          el.data.brand &&
                          String(el.data.brand).toLowerCase().includes(tf) ||
                        filterFields.vendorCode.active &&
                          el.data.vendorCode &&
                          String(el.data.vendorCode).toLowerCase().includes(tf) ||
                        // filterFields.barcode.active &&
                        //   el.expanded && 
                        //   el.expanded.filter((fel) => fel.size.barcode && String(fel.size.barcode).toLowerCase().includes(tf)).length > 0 ||
                        filterFields.barcode.active &&
                          el.expanded &&
                          el.expanded.filter((fel) => fel.size.barcodes && fel.size.barcodes.findIndex((bel) => String(bel).toLowerCase().includes(tf))> -1).length > 0
                      )
                    })}
                    onFormatterChange={changeTableRow}
                    autoPagination={15}
                  />
                </div>
              </Scrollbars>
            }
          </div>

        </Box>
    );

}